<script lang="ts" setup>
import { ref, computed } from "vue";

const VARIANT_VALUES = ["outlined", "contained"] as const;
type VariantType = typeof VARIANT_VALUES[number];

const props = defineProps<{
  variant?: VariantType;
  label: string;
}>();

const variant = ref(props.variant || "outlined");

const isOutlinedStyle = computed(() => variant.value === "outlined");
const tagClass = computed(() => (isOutlinedStyle.value ? "tag-outlined" : ""));

if (!VARIANT_VALUES.includes(variant.value)) {
  console.warn(
    `Invalid prop: variant should be one of ${VARIANT_VALUES.join(", ")}`
  );
}
</script>

<template>
  <div class="tag-base" :class="tagClass">
    <BeginnerMark class="beginner-mark" />
    {{ label }}
  </div>
</template>

<style lang="scss" scoped>
.tag-base {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  font-size: 14px;
  line-height: 19px;
  color: $gray-05;
  text-align: center;
  background-color: $white;
  border-radius: 4px;
}
</style>
